import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import Axios from './assets/js/axios'

import iView from 'iview';
import 'iview/dist/styles/iview.css';

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
import { stat } from 'fs';
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(iView);

Vue.prototype.$post = Axios.post
Vue.prototype.$get = Axios.get
Vue.prototype.$postImage = Axios.postImage
Vue.prototype.$changeBaseUrl = Axios.changeBaseUrl

Vue.prototype.openWindow = function (path,params={},type=1){  
  if(type == 1){
    this.$router.push({'name':path,'params':params})
  }else{
    this.$router.replace({path:path,query:params})
  }
}  

Vue.prototype.judgeStatusShow = function(status,type){
  let show = ''
  let show2 = ''
  switch (status) {
    case 0:
      show = '未开始'
      show2 = '即将直播'
      break
    case 1:
      show = '直播中'
      show2 = '点击直播'
      break
    case 2:
      show = '已结束'
      show2 = '点击回放'
      break
  }
  if(type == 1){
    return show
  }else{
    return show2
  }
}
Vue.prototype.getClassTime = function(start,duration){
  var startDate = new Date(start*1000)
  var endDate = new Date(start*1000+duration*60*1000)
  return (parseInt(startDate.getMonth())+parseInt(1))+'月'+startDate.getDate()
    +'日 ' + PrefixInteger(startDate.getHours())+':'+ PrefixInteger(startDate.getMinutes())+'-'
        + PrefixInteger(endDate.getHours())+':'+PrefixInteger(endDate.getMinutes())
}
function PrefixInteger(num) {
  return (Array(2).join('0') + num).slice(-2);
 }


Vue.prototype.toast = function(msg,close=false,duration=5){
  this.$Message.info({
    content: msg,
    duration: duration,
    closable: close
  })
}

//资源存放地址
Vue.prototype.resUrl = 'https://best-ecology.oss-cn-hangzhou.aliyuncs.com/'
Vue.prototype.audioUrl = 'https://hichinese-api.pk0818.com'
Vue.prototype.splitUrl = function(url,suff='',style=''){
  if(style == 'portrait' && !url){
    url = '/avatar/default.png'
  }
  if(!url) return
  if(url.indexOf('http') !== -1){
    return url
  }
  if(suff !== ''){
    return this.resUrl + url + suff
  }
  if(url.indexOf('jpg')!==-1 || url.indexOf('png')!==-1 || url.indexOf('jpeg')!==-1){
    return this.resUrl + url
    // + '-watermark'
  }else{
    return this.resUrl + url
  }
}

const store = new Vuex.Store({
  state:{
    userData:{
      avatar: "",
      cid: 1,
      nickname: "",
      openid: "",
      sex: 1,
      token: "",
      id: "",
      verified: 0,
    },
    reClassList:0,
    reClassInfo:0
  },
  mutations:{
    changeApp (state,data){
      for(let i in data){
        this.state.appData[i] = data[i]
      }
    },
    changeUser(state,data){
      for(let i in data){
        this.state.userData[i] = data[i]
      }
    },
    clearUser(state,data){
      for(let i in this.state.userData){
        this.state.userData[i] = ''
      }
    },
    refreshClassList(state,data){
      console.log('refresh')
      this.state.reClassList ++
    },
    refreshClassInfo(state,data){
      this.state.reClassInfo ++
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
